import { ClassCast } from '@shared/zb-object-helper/class-cast';
import { DockGroupCardModel } from './dock-group-card.model';

export class DockGroupModel {
  dockGroupId: string = undefined;
  dockGroupName: string = undefined;
  dockGroupSkillArea: string = undefined;
  @ClassCast(DockGroupCardModel)
    dockGroupCards: DockGroupCardModel[] = [];
}
